import React, { useMemo } from 'react';
import { Box } from '@fullstory/components';
import { useLocationMapImage } from '@fullstory/redux';
import css from './index.module.scss';

interface LocationMapProps {
  latLong?: string;
}

export const LocationMap: React.FC<LocationMapProps> = ({ latLong }) => {
  const backgroundImage = useLocationMapImage(latLong);
  const mapStyle = useMemo(
    () =>
      backgroundImage
        ? {
            backgroundImage: `url(${backgroundImage})`,
          }
        : undefined,
    [backgroundImage],
  );
  return (
    <Box data-component="LocationMap" width={1} height={100} className={css.map} style={mapStyle} />
  );
};
